import { render, staticRenderFns } from "./CustomersSearch.vue?vue&type=template&id=71a2ef06&"
import script from "./CustomersSearch.vue?vue&type=script&lang=js&"
export * from "./CustomersSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports